import { STATUSES } from './statuses';

export const STATUSES_FOR_FILTERING: Array<{
  id: string;
  name: string;
}> = Object.keys(STATUSES).reduce((acc, cur) => {
  acc.push({
    id: cur,
    name: STATUSES[cur],
  });
  return acc;
}, []);
